import { Button, Card, CardContent } from "@material-ui/core";
import React, { Component } from "react";
import TableListPTMengisi from "./components/presentase-mengisi/Table";
class DetailsTelahMengisi extends Component {
    render(){
      let userdata = JSON.parse(localStorage.getItem('sessiondata'));
      let access = userdata.i_idrole;
        return(
            <>
            <div className="row row-paddingless">
              <div className="col-md-12 text-right" style={{marginBottom:'20px'}}>
                <a href="/spmi/dashboard">
                  <Button className="btn btn-primary">
                    <i className="flaticon2-back"></i>
                    Kembali
                  </Button>
                </a>
              </div>
            </div>
            <Card>
              <CardContent>
                <TableListPTMengisi />
              </CardContent>
            </Card>
            </>
        )
    }
}
export default DetailsTelahMengisi;